export default "__VITE_ASSET__BRWfeAmX__"